import type { ProductEventAction, ProductFeatureSurface } from "./product-feature-definition";

/**
 * The browser's half of usage analytics (PREC-4330, 3/10): what the web app and the Chrome
 * extension send to `POST /product-events`, with their normal authenticated requests.
 *
 * An item names a catalog feature, an action and the surface it was used on, nothing else: the
 * company, the user, the staff flag and the time come from the JWT and the server, never from the
 * body (privacy policy §5.2). Unknown items are dropped by the API, not refused.
 */

/** The only surfaces a browser may report; `mcp` and `api` are recorded by the server itself. */
export const PRODUCT_EVENT_INGEST_SURFACES = ["web", "extension"] as const satisfies readonly ProductFeatureSurface[];

export type ProductEventIngestSurface = (typeof PRODUCT_EVENT_INGEST_SURFACES)[number];

/** The most items one `POST /product-events` may carry; the API refuses a longer batch. */
export const PRODUCT_EVENT_INGEST_MAX_ITEMS = 50;

export interface ProductEventIngestItem {
	readonly feature: string;
	readonly action: ProductEventAction;
	readonly surface: ProductEventIngestSurface;
}

export interface ProductEventIngestRequest {
	readonly events: readonly ProductEventIngestItem[];
}
